// extracted by mini-css-extract-plugin
export default {"wrapper":"kz-z","viewport":"lz-z","container":"mz-z","slide":"nz-z"};